import * as React from 'react'
import { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'
import Logo from '@doordash/component-logo'
import { Colors, Spacing } from '@doordash/design-language'

type NavbarProps = {
  isLogoDisplayed?: boolean
  onLogoClick?: (e: React.MouseEvent<HTMLElement>) => void
}

/**
 * A simple navbar which by default renders a logo on the top left.
 */
const Navbar: React.FC<NavbarProps & ComponentPropsWithoutRef<'div'>> = ({
  isLogoDisplayed = true,
  onLogoClick,
  children,
  ...props
}) => {
  const handleLogoClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onLogoClick) {
      onLogoClick(e)
    }
  }

  return (
    <NavbarContainer {...props}>
      {isLogoDisplayed ? (
        <StyledLogo
          onClick={handleLogoClick}
          isClickable={typeof onLogoClick === 'function'}
        />
      ) : null}
      {children}
    </NavbarContainer>
  )
}

const NavbarContainer = styled.div`
  width: 100%;
  padding: ${Spacing.Medium}px ${Spacing.Small}px;

  box-shadow: inset 0px -1px 0px ${Colors.SystemGrey5};
  background-color: ${Colors.SystemWhite};

  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledLogo = styled(Logo)<{ isClickable: boolean }>`
  ${({ isClickable }) =>
    isClickable &&
    `
    cursor: pointer;
  `}
`

export default Navbar
